@let isInReplacementMode = fullContainer.children.length !== 0;

<dialog #modal class="modal" (click)="backdropClick($event)">
  <div
    class="modal-box p-0"
    [ngClass]="[widthClass()]"
    [class.bg-transparent]="isInReplacementMode"
    [class.shadow-none]="isInReplacementMode"
  >
    <div #fullContainer>
      <ng-content select="[replacement]"></ng-content>
    </div>

    <div
      class="card bg-base-100 shadow-xl page-card mx-auto"
      [class.hidden]="isInReplacementMode"
    >
      <div class="card-body">
        <div class="type-page-title flex justify-center relative">
          <ng-content select="[title]"></ng-content>

          <div class="absolute top-[-4px] right-2 flex items-center gap-2">
            <ng-content select="[titleActions]"></ng-content>

            @if (showCloseButton()) {
              <app-button-close (click)="closeModal()"></app-button-close>
            }
          </div>
        </div>

        <div class="type-flavor text-center empty:hidden">
          <ng-content select="[subtitle]"></ng-content>
        </div>

        <div class="my-2">
          <ng-content select="[body]"></ng-content>
        </div>

        <div class="card-actions justify-end">
          <ng-content select="[actions]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</dialog>
